module.exports = __webpack_public_path__ + "img/credenciales-facebook.db705cc9.svg";